const migrations = {
  0: (state) => ({
    ...state,
  }),
  1: (state) => ({
    ...state,
    User: {
      ...state.User,
      youTubeAuth: state.User.googleAuth,
    },
  }),
  2: (state) => ({
    ...state,
    User: {
      ...state.User,
      counters: {
        followCounter: {
          follow: 0,
          followers: 0,
        },
        postCounter: {
          facebook: 0,
          instagram: 0,
          twitter: 0,
          marble: 0,
          total: 0,
        },
      },
    },
  }),
};

export default migrations;
